"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationStatusType;
(function (NotificationStatusType) {
    NotificationStatusType["SHOW"] = "SHOW";
    NotificationStatusType["HIDE"] = "HIDE";
})(NotificationStatusType = exports.NotificationStatusType || (exports.NotificationStatusType = {}));
//# sourceMappingURL=NotificationStatusType.js.map